import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as bomSelectors, actions as bomActions } from 'ducks/pickSlips/bom';
import { fetchBOM } from 'api/pickSlips/bom';
import { actions as filterActions } from 'ducks/common/filters';
import { selectors as pickSlipSelectors } from 'ducks/pickSlips/pickSlipTransaction';
import { selectors as slipLineSelectors } from 'ducks/pickSlips/slipLines';
import { IApplicationState } from 'ducks/reducers';

const params = new URLSearchParams(location.search);

export const mapStateToProps = (state: IApplicationState) => ({
  gridName: 'PSBOM',
  columnDefs: bomSelectors.lineColumns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state),
  gridOptions: bomSelectors.gridOptions(state),
  reqParams: ((pickSlipSelectors.selected(state) || params.get('DespatchId')) && (slipLineSelectors.selected(state) || params.get('LineNumber')))
    &&
    {
      DespatchId: (pickSlipSelectors.selected(state) && pickSlipSelectors.selected(state).DespatchId) || params.get('DespatchId'),
      LineNumber: (slipLineSelectors.selected(state) && slipLineSelectors.selected(state).LineNumber) || params.get('LineNumber')
    },
  keyFields: [{ valueField: 'LineNumber', routeField: 'BOMLineNumber' }],
  apiMethod: fetchBOM
});

export const actions = {
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: bomActions.setSelected,
  applyFilters: filterActions.applyFilters
};
